import { alpha } from '@mui/material/styles';
import { toggleButtonClasses } from '@mui/material/ToggleButton';
// ----------------------------------------------------------------------
const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
// ----------------------------------------------------------------------
export function toggleButton(theme) {
    const rootStyles = (ownerState) => {
        const defaultStyle = {
            borderRadius: 50,
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
            },
            [`&.${toggleButtonClasses.selected}`]: {
                borderColor: 'currentColor',
                boxShadow: '0 0 0 0.5px currentColor',
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main,
                // 👇 stop hover from changing anything when selected
                '&:hover': {
                    backgroundColor: theme.palette.primary.main,
                },
            },
        };
        const colorStyle = COLORS.map((color) => ({
            ...(ownerState.color === color && {
                // only apply hover style if NOT selected
                [`&:not(.${toggleButtonClasses.selected}):hover`]: {
                    borderColor: alpha(theme.palette[color].main, 0.48),
                    backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
                },
            }),
        }));
        const disabledState = {
            [`&.${toggleButtonClasses.disabled}`]: {
                [`&.${toggleButtonClasses.selected}`]: {
                    color: theme.palette.action.disabled,
                    backgroundColor: theme.palette.action.selected,
                    borderColor: theme.palette.action.disabledBackground,
                },
            },
        };
        return [defaultStyle, ...colorStyle, disabledState];
    };
    return {
        MuiToggleButton: {
            styleOverrides: {
                root: ({ ownerState }) => rootStyles(ownerState),
            },
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    borderRadius: 50,
                    backgroundColor: theme.palette.background.paper,
                    //border: `solid 1px ${alpha(theme.palette.grey[500], 0.08)}`,
                },
                grouped: {
                    margin: 4,
                    [`&.${toggleButtonClasses.selected}`]: {
                        boxShadow: 'none',
                    },
                    '&:not(:first-of-type), &:not(:last-of-type)': {
                        borderRadius: 50,
                        borderColor: 'transparent',
                    },
                },
            },
        },
    };
}
